import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center h-full" }
const _hoisted_2 = { class: "text-red-500" }

import { ref } from "vue";
import LoginPage from "./components/LoginPage.vue";
import SetBoothKey from "./components/SetBoothKey.vue";
import BaseInformation from "./components/BaseInformation.vue";
import ShowServices from "./components/ShowServices.vue";
import GenericButton from "./components/ui/GenericButton.vue";
import GenericModal from "./components/ui/GenericModal.vue";
import { personBaseData } from "./utils/interfaces";
import { useIdleTimer } from "@/composables/useIdleTimer";

enum View {
  Login = "login",
  SetBoothKey = "setBoothKey",
  BaseInformation = "baseInformation",
  ShowServices = "ShowServices",
}


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const currentView = ref<View>(View.Login);
const personData = ref({} as personBaseData);
const showIdleModal = ref(false);
const timeBack = ref(15);
const isReseted = ref(false);

const { pause, resume, setTimeoutValue } = useIdleTimer({
  onIdle: () => {
    showIdleModal.value = true;
    const setTimeBack = () => {
      setTimeout(() => {
        if (isReseted.value) {
          showIdleModal.value = false;
          timeBack.value = 15;
          isReseted.value = false;
          return;
        }
        if (timeBack.value === 0) {
          showIdleModal.value = false;
          timeBack.value = 15;
          changeView(View.BaseInformation);
          return;
        }
        timeBack.value = timeBack.value - 1;
        setTimeBack();
      }, 1000);
    };
    pause();
    setTimeBack();
  },
});

async function handleClick() {
  if (
    process.env.VUE_APP_DEBUG !== "true" &&
    document.documentElement.requestFullscreen
  ) {
    try {
      await document.documentElement.requestFullscreen();
      document.addEventListener("contextmenu", function (e) {
        e.preventDefault();
      });

      document.addEventListener("keydown", function (e) {
        if (!e || !e.key) return;
        const key = e.key.toLowerCase();

        // Bloquea F12
        if (key === "f12") {
          e.preventDefault();
          console.log("F12 bloqueada");
        }

        // Bloquea Ctrl+Shift+I
        if (e.ctrlKey && e.shiftKey && key === "i") {
          e.preventDefault();
          console.log("Ctrl+Shift+I bloqueado");
        }

        // Bloquea Ctrl+Shift+C
        if (e.ctrlKey && e.shiftKey && key === "c") {
          e.preventDefault();
          console.log("Ctrl+Shift+C bloqueado");
        }

        // Bloquea Ctrl+U
        if (e.ctrlKey && key === "u") {
          e.preventDefault();
          console.log("Ctrl+U bloqueado");
        }

        // Bloquea Escape
        if (key === "escape" || e.keyCode === 27) {
          e.preventDefault();
          e.stopPropagation();
          console.log("Tecla Escape bloqueada");
        }
      });
    } catch (err) {
      console.error("Error al intentar pantalla completa:", err);
    }
  }
}

async function resetIdleTimer() {
  isReseted.value = true;
  resume();
}

function changeView(view: View, data?: any) {
  currentView.value = view;
  if (data) {
    const { afiliacion } = data;
    const { numeroPlanAsociado, referencia, idPersona } = afiliacion;
    personData.value.numeroPlanAsociado = numeroPlanAsociado;
    personData.value.referencia = referencia;
    personData.value.idPersona = idPersona;
    personData.value.nroOrden = data.nroOrden;
    personData.value.email = data.email;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "h-screen w-screen overflow-auto flex items-center justify-center",
    onClick: handleClick
  }, [
    (currentView.value === View.Login)
      ? (_openBlock(), _createBlock(LoginPage, {
          key: 0,
          onChangeView: changeView
        }))
      : (currentView.value === View.SetBoothKey)
        ? (_openBlock(), _createBlock(SetBoothKey, {
            key: 1,
            onChangeView: changeView
          }))
        : (currentView.value === View.BaseInformation)
          ? (_openBlock(), _createBlock(BaseInformation, {
              key: 2,
              onChangeView: changeView,
              onPauseTimer: _unref(pause)
            }, null, 8, ["onPauseTimer"]))
          : (_openBlock(), _createBlock(ShowServices, {
              key: 3,
              onChangeView: changeView,
              onSetTimeout: _unref(setTimeoutValue),
              onResumeTimer: _unref(resume),
              onPauseTimer: _unref(pause),
              personData: personData.value,
              allow: "camera; microphone",
              allowfullscreen: ""
            }, null, 8, ["onSetTimeout", "onResumeTimer", "onPauseTimer", "personData"])),
    (showIdleModal.value)
      ? (_openBlock(), _createBlock(GenericModal, {
          key: 4,
          class: "flex flex-col items-cente rounded p-6 z-index-[9999]",
          openOnMount: true,
          id: "idleModal"
        }, {
          actions: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("span", _hoisted_2, "Se terminará la sesión en " + _toDisplayString(timeBack.value) + " segundos", 1),
              _createVNode(GenericButton, {
                class: "px-3 py-1.5",
                onClick: resetIdleTimer
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("Sí")
                ])),
                _: 1,
                __: [0]
              })
            ])
          ]),
          default: _withCtx(() => [
            _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "text-2xl font-bold" }, "Se ha detectado inactividad", -1)),
            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-xl text-center" }, "¿Continua ahí?", -1))
          ]),
          _: 1,
          __: [1,2]
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})